import styled from "styled-components"
import { formatPriceByLocale } from "utils/utils"

export default function ProductHeader({
  title,
  discountPercent,
  lowestPrice,
  lowestChallengePrice,
  period,
  minAuth,
}) {
  let authPeriodText = ""
  if (period % 7 === 0) {
    authPeriodText = `${period / 7}주간 ${minAuth}회 인증 시, 환급`
  } else {
    authPeriodText = `${period}일간 ${minAuth}회 인증 시, 환급`
  }

  return (
    <ProductHeaderWrapper>
      <ProductTitle>{title}</ProductTitle>
      <PriceInfoBlock>
        <DiscountPercent>{discountPercent}%</DiscountPercent>
        <FullPrice>{formatPriceByLocale("ko", lowestPrice)}원</FullPrice>
      </PriceInfoBlock>
      <RefundInfo>
        성공 시 {lowestChallengePrice && formatPriceByLocale("ko", lowestChallengePrice)}원 구매
      </RefundInfo>
      <AuthInfoBlock>
        <AuthInfo>{`${authPeriodText}`}</AuthInfo>
      </AuthInfoBlock>
    </ProductHeaderWrapper>
  )
}

const ProductHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const ProductTitle = styled.h2`
  font-weight: 700;
  font-size: calc(100vw * (23 / 375));
  line-height: calc(100vw * (28 / 375));
  margin-bottom: calc(100vw * (12 / 375));
`

const PriceInfoBlock = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: calc(100vw * (3 / 375));
`

const DiscountPercent = styled.span`
  font-weight: 700;
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (24 / 375));
  margin-right: calc(100vw * (7 / 375));
  color: #ff6b00;
`

const FullPrice = styled.span`
  font-weight: 600;
  font-size: calc(100vw * (16 / 375));
  line-height: calc(100vw * (19 / 375));
  text-decoration-line: line-through;
  color: #c6c6c6;
`

const RefundInfo = styled.div`
  font-weight: 700;
  font-size: calc(100vw * (20 / 375));
  line-height: calc(100vw * (24 / 375));
  color: #4e4e4e;
`

const AuthInfoBlock = styled.div`
  display: flex;
  margin-top: calc(100vw * (8 / 375));
`

const AuthInfo = styled.p`
  font-size: calc(100vw * (12 / 375));
  font-weight: 600;
  color: #7f7f7f;
  background-color: #f7f7f7;
  border-radius: calc(100vw * (6 / 375));
  padding: calc(100vw * (8 / 375)) calc(100vw * (10 / 375));
`
